import { Badge } from "@/components/Badge.tsx";
import { EnumBadge, type EnumProps, withEnumBadge } from "@/components/EnumBadge.tsx";
import type { DocumentTypes, InvoiceTypes } from "@warrenio/api-spec/spec.oats.gen";

/* eslint-disable react-refresh/only-export-components */

export const reportTypes: Record<InvoiceTypes, EnumProps> = {
    cloud_services: { label: "Cloud Services", color: "info" },
    credit_topup: { label: "Credit Topup", color: "warning" },
    credit_note: { label: "Credit Note", color: "success" },
};

export const ReportType = withEnumBadge(reportTypes);

export const documentTypes: Record<DocumentTypes, EnumProps> = {
    invoice: { label: "Invoice", color: "primary" },
    credit_note: { label: "Credit Note", color: "success" },
    report: { label: "Report", color: "info" },
};

// Can be `null` for some legacy data? (at least in test environment)
export function DocumentTypeLabel({ value }: { value: DocumentTypes | null | undefined }) {
    if (value == null) {
        return <Badge color="error">Unknown</Badge>;
    }
    return <EnumBadge options={documentTypes} value={value} />;
}
